export default "__VITE_ASSET__FOpSHTSE__$_?format=webp__"